export const tokenTimeout = 0.5; // 前端 token 超时时间 单位H

export const redirectUrl = 'https://product.gaojidata.com' // 第三方登录重定向地址，注意末尾没有 "/"
